module.exports = __webpack_public_path__ + "img/16.4e227120.jpg";